export default "__VITE_ASSET__DGRQ42bW__"